import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "jm_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (err?.response?.status === 403 && typeof detail === "string" && detail.toLowerCase().includes("deactivated")) {
      clearToken();
      if (!window.location.pathname.startsWith("/login")) {
        window.location.assign(`/login?deactivated=1`);
      }
    }
    return Promise.reject(err);
  }
);

export const homeForRole = (role) =>
  role === "ADMIN" ? "/admin" : role === "EXPERT" ? "/teacher" : "/student";
